module.exports = __webpack_public_path__ + "img/house-duotone.7d0e1c01.svg";